function logger(type, ...args) {
    console[type]('[web2client]', ...args);
}
function log(...args) {
}
function error(...args) {
    logger('error', ...args);
}

export { error, log };
//# sourceMappingURL=logger.js.map
